import CursorIcon from '@atlaskit/icon-lab/core/cursor';
import * as React from 'react';

export const SvgCursor = () => {
  return <CursorIcon label="" testId="ads-refreshed-icon" />;
};
